// Service definitions used across pages
export const SERVICES = [
  {
    slug: "mutual-funds",
    title: "Mutual Funds",
    short: "Curated equity, debt, and hybrid funds aligned to your goals and risk profile.",
    icon: "TrendingUp",
    description:
      "We construct multi-fund portfolios using research-driven selection — covering equity, debt, hybrid, and thematic strategies. Our process emphasizes consistent alpha, expense efficiency, and disciplined rebalancing.",
    points: [
      "Goal-linked SIP and lump-sum strategies",
      "Direct plan advisory with ongoing reviews",
      "Tax-aware switching & STP/SWP planning",
    ],
  },
  {
    slug: "stocks-demat",
    title: "Stocks & Demat Accounts",
    short: "Open Demat accounts and access institutional-grade equity research.",
    icon: "LineChart",
    description:
      "Seamless onboarding for resident and NRI Demat accounts paired with research-led equity ideas across large, mid, and small cap universes.",
    points: [
      "End-to-end Demat & trading account setup",
      "Bottom-up research and sectoral views",
      "Concentrated equity advisory portfolios",
    ],
  },
  {
    slug: "nri-investment",
    title: "NRI Investment Services",
    short: "Compliant cross-border investing for non-resident Indians worldwide.",
    icon: "Globe2",
    description:
      "From NRE/NRO accounts to PIS, FCNR, and repatriation strategies — we help NRIs invest into India with full FEMA & tax compliance and a single point of contact.",
    points: [
      "NRE/NRO/FCNR account guidance",
      "PIS-enabled equity & MF investing",
      "DTAA, repatriation & estate planning",
    ],
  },
  {
    slug: "pms-aif",
    title: "PMS & AIF",
    short: "Discretionary portfolio management and alternative investment funds.",
    icon: "Briefcase",
    description:
      "Access top-tier PMS strategies and SEBI-registered AIFs (Cat I, II, III) handpicked for HNI portfolios — including long-only, long-short, private credit, and venture exposure.",
    points: [
      "PMS shortlisting based on rolling alpha & drawdown",
      "Cat II private credit and Cat III long-short funds",
      "Quarterly portfolio attribution reviews",
    ],
  },
  {
    slug: "sif",
    title: "SIF (Structured Investment Funds)",
    short: "Structured products engineered for defined risk-return outcomes.",
    icon: "Layers",
    description:
      "Capital-protected and yield-enhancement structures issued by leading institutions — designed for investors seeking asymmetric payoffs and downside buffers.",
    points: [
      "Capital protected MLDs & equity-linked notes",
      "Issuer credit assessment & payoff modelling",
      "Suitability mapping to portfolio mandates",
    ],
  },
  {
    slug: "gift-city-funds",
    title: "GIFT City Funds",
    short: "USD-denominated investing through India's IFSC at GIFT City.",
    icon: "Building2",
    description:
      "Tap regulated GIFT IFSC funds for tax-efficient global allocation — ideal for NRIs, family offices, and HNIs seeking USD diversification.",
    points: [
      "IFSCA-regulated AIFs and feeder funds",
      "USD investment with India-grade governance",
      "Tax-efficient structuring for non-residents",
    ],
  },
  {
    slug: "corporate-fds-bonds",
    title: "Corporate FDs & Bonds",
    short: "Fixed-income laddering across corporate FDs, NCDs, and government bonds.",
    icon: "Banknote",
    description:
      "Income-oriented portfolios built across AAA/AA corporate FDs, listed NCDs, tax-free bonds, sovereign and state development loans.",
    points: [
      "Credit-screened corporate FDs & NCDs",
      "G-Sec, SDL & tax-free bond access",
      "Yield-curve based laddering strategies",
    ],
  },
  {
    slug: "treasury-management",
    title: "Treasury Management",
    short: "Liquidity, working-capital and surplus deployment for corporates.",
    icon: "Wallet",
    description:
      "Cash management and short-tenor allocation programmes for corporate treasuries — balancing liquidity, safety, and yield with policy-aligned mandates.",
    points: [
      "Liquidity laddering & sweep strategies",
      "Treasury policy review & implementation",
      "MIS dashboards and audit-ready reporting",
    ],
  },
  {
    slug: "wills-estate-planning",
    title: "Wills & Estate Planning",
    short: "Wills, trusts and structures that protect what you have built.",
    icon: "ScrollText",
    description:
      "We co-create estate plans with experienced legal partners — drafting Wills, private trusts, and family constitutions that ensure smooth, dispute-free transitions.",
    points: [
      "Will drafting, custody & registration",
      "Private family trusts & nominee strategy",
      "Cross-border succession structures",
    ],
  },
  {
    slug: "portfolio-restructuring",
    title: "Portfolio Restructuring",
    short: "A second opinion that re-aligns inherited or fragmented portfolios.",
    icon: "Repeat",
    description:
      "Comprehensive review of legacy portfolios to identify overlap, concentration, tax inefficiencies, and underperformers — followed by a calibrated transition plan.",
    points: [
      "Holdings consolidation & overlap analysis",
      "Tax-efficient transition plans",
      "Risk re-mapping to current goals",
    ],
  },
  {
    slug: "retirement-planning",
    title: "Retirement Planning",
    short: "Inflation-proof retirement income built decades ahead.",
    icon: "Hourglass",
    description:
      "Goal-based retirement plans combining accumulation strategies, healthcare buffers, and post-retirement income engines like SWPs and annuities.",
    points: [
      "Retirement corpus modelling & gap analysis",
      "Sequencing risk & withdrawal strategies",
      "Healthcare and longevity buffers",
    ],
  },
  {
    slug: "succession-planning",
    title: "Succession Planning",
    short: "Multi-generational wealth transition for families and businesses.",
    icon: "Network",
    description:
      "Holistic succession frameworks for promoter families and business owners — combining shareholding structures, governance, and liquidity events.",
    points: [
      "Family governance charters",
      "Holding & operating entity structures",
      "Liquidity, gifting and trust integration",
    ],
  },
];

export const findService = (slug) => SERVICES.find((s) => s.slug === slug);
